import React from "react";
import { Link } from "react-router-dom";
import { BrpLogo } from "@/components/brand/BrpLogo";
import { NAV } from "@/constants/testIds";
import { Linkedin, Instagram, Youtube, Twitter, Mail } from "lucide-react";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border/70 bg-background">
      <div className="mx-auto w-full max-w-7xl px-5 sm:px-8 lg:px-10 py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4 space-y-4">
            <BrpLogo size={22} tone="dark" />
            <p className="max-w-xs text-sm text-[hsl(var(--brp-ink-dim))] leading-relaxed">
              Brilliant Regular People Tech. Human-centered technology designed to eliminate operational friction and create lasting impact.
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="text-[11px] tracking-[0.28em] uppercase text-[hsl(var(--brp-ink-dim))] mb-4">Company</div>
            <ul className="space-y-3 text-sm">
              <li><Link className="text-[hsl(var(--brp-ink))] hover:text-[hsl(var(--brp-blue))]" to="/about">About</Link></li>
              <li><Link className="text-[hsl(var(--brp-ink))] hover:text-[hsl(var(--brp-blue))]" to="/careers">Careers</Link></li>
              <li><Link className="text-[hsl(var(--brp-ink))] hover:text-[hsl(var(--brp-blue))]" to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.28em] uppercase text-[hsl(var(--brp-ink-dim))] mb-4">Initiative</div>
            <ul className="space-y-3 text-sm">
              <li>
                <Link className="text-[hsl(var(--brp-ink))] hover:text-[hsl(var(--brp-blue))]" to="/legacy-league">
                  Initiative &nbsp;·&nbsp; <span className="italic text-[hsl(var(--brp-ink-dim))]">Legacy League</span>
                </Link>
              </li>
              <li>
                <Link className="text-[hsl(var(--brp-ink))] hover:text-[hsl(var(--brp-blue))]" to="/donate">
                  Support the Mission
                </Link>
              </li>
            </ul>
            <div className="text-[11px] tracking-[0.28em] uppercase text-[hsl(var(--brp-ink-dim))] mt-8 mb-4">Legal</div>
            <ul className="space-y-3 text-sm">
              <li><Link className="text-[hsl(var(--brp-ink))] hover:text-[hsl(var(--brp-blue))]" to="/privacy">Privacy Policy</Link></li>
              <li><Link className="text-[hsl(var(--brp-ink))] hover:text-[hsl(var(--brp-blue))]" to="/terms">Terms &amp; Conditions</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.28em] uppercase text-[hsl(var(--brp-ink-dim))] mb-4">Connect</div>
            <div className="flex items-center gap-4 text-[hsl(var(--brp-ink-dim))]">
              <a href="#" aria-label="LinkedIn" className="hover:text-[hsl(var(--brp-blue))]"><Linkedin className="h-5 w-5" /></a>
              <a href="#" aria-label="Twitter" className="hover:text-[hsl(var(--brp-blue))]"><Twitter className="h-5 w-5" /></a>
              <a href="#" aria-label="Instagram" className="hover:text-[hsl(var(--brp-blue))]"><Instagram className="h-5 w-5" /></a>
              <a href="#" aria-label="YouTube" className="hover:text-[hsl(var(--brp-blue))]"><Youtube className="h-5 w-5" /></a>
              <a href="mailto:hello@brptech.com" aria-label="Email" className="hover:text-[hsl(var(--brp-blue))]"><Mail className="h-5 w-5" /></a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-border/70 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3" data-testid={NAV.footerNav}>
          <div className="text-xs text-[hsl(var(--brp-ink-dim))]">
            © {year} Brilliant Regular People Tech. All Rights Reserved.
          </div>
          <div className="text-xs text-[hsl(var(--brp-ink-dim))] italic">“Solving Today. Inventing Tomorrow.”</div>
        </div>
      </div>
    </footer>
  );
};
